{
  "es": {
    "lot": {
      "attributes": {
        "end_date": "Fecha de fin",
        "internal_note": "Nota interna de la parcela",
        "land_register": "Registro de la propiedad",
        "name": "Nombre",
        "start_date": "Fecha de inicio",
        "surface": "Superficie"
      },
      "labels": {
        "lot": "Ninguna parcela | Una parcela | {count} parcelas"
      },
      "toasts": {
        "create": "Parcela creada",
        "delete": "Parcela eliminada",
        "update": "Parcela actualizada"
      },
      "validation": {
        "needName": "Se requiere un título",
        "needNumber": "Debe ser un número (p. ej. 85)"
      }
    }
  }
}
